import React from 'react';
import { CurrencyDollarIcon, ChartPieIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import CommonPageHeader from '../components/common/CommonPageHeader';

const FleetExpenses: React.FC = () => {
  return (
    <div className="space-y-6">
      <CommonPageHeader
        title="Költségek"
        subtitle="Költség áttekintés, járműnkénti költségek és riportok"
        icon={CurrencyDollarIcon}
      />

      {/* Flotta modul overlay */}
      <div className="relative">
        <div className="absolute inset-0 bg-gray-900/5 dark:bg-gray-900/20 backdrop-blur-[0.5px] z-10 rounded-lg flex items-center justify-center">
          <div className="bg-white/95 dark:bg-gray-800/95 px-8 py-6 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-md text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-primary-400 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">🚗</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Flotta Modul</h3>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
              Ez a funkció a Flotta modul részét képezi
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              A Költségek modul külön megrendelés tárgya.
            </p>
          </div>
        </div>

        {/* Teljes működő tartalom (elmosódva) */}
        <div className="pointer-events-none opacity-70 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <CurrencyDollarIcon className="w-8 h-8 text-green-600 mb-2" />
              <h3 className="font-semibold mb-1">Havi összes költség</h3>
              <p className="text-2xl font-bold">2,850,000 Ft</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <ChartPieIcon className="w-8 h-8 text-blue-600 mb-2" />
              <h3 className="font-semibold mb-1">Átlag járműnként</h3>
              <p className="text-2xl font-bold">118,750 Ft</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <ArrowTrendingUpIcon className="w-8 h-8 text-red-600 mb-2" />
              <h3 className="font-semibold mb-1">Változás (havi)</h3>
              <p className="text-2xl font-bold">+12%</p>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold mb-4">Költségek kategóriánként</h3>
            <div className="space-y-3">
              {[
                { category: 'Üzemanyag', amount: '1,250,000 Ft', percent: '44%' },
                { category: 'Karbantartás', amount: '850,000 Ft', percent: '30%' },
                { category: 'Biztosítás', amount: '450,000 Ft', percent: '16%' },
                { category: 'Egyéb', amount: '300,000 Ft', percent: '10%' },
              ].map((item, i) => (
                <div key={i} className="flex items-center justify-between border-b pb-2">
                  <div>
                    <p className="font-medium">{item.category}</p>
                    <p className="text-sm text-gray-600">{item.percent} az összes költségből</p>
                  </div>
                  <p className="font-bold text-lg">{item.amount}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetExpenses;
